<template>
  <section :class="$style.container">
    <a
      :class="[$style.textLink, customLinkStyle]"
      :href="kbLink"
      rel="noopener noreferrer"
      target="_blank"
    >
      <slot>
        {{ kbLinkText }}
      </slot>
    </a>
    <a
      v-if="showReadMoreIcon"
      :class="$style.iconLink"
      :href="kbLink"
      rel="noopener noreferrer"
      target="_blank"
    >
      <i :class="['jc-tool-kb', $style.icon]" />
    </a>
  </section>
</template>

<script>
export default {
  name: 'IconTooltipReadMore',

  props: {
    customLinkStyle: {
      type: [String, Array],
      default: '',
    },

    kbLink: {
      type: String,
      required: true,
    },

    kbLinkText: {
      type: String,
      default: 'Read the Knowledge Base',
    },

    showReadMoreIcon: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped module>
.container {
  display: flex;
  justify-content: flex-end;
  margin-left: -1.6rem;
  padding-top: 5px;
}

.icon {
  color: var(--jc-color-informational-base);
  font-size: 25px;
}

.iconLink:hover {
  text-decoration: none;
}

.textLink {
  font-style: italic;
  font-weight: 600 !important;
  letter-spacing: 0.2px;
  line-height: 2.2;
  padding-right: 8px;
}
</style>
